






























import Vue from "vue";
import { ToastOptions } from "./ToastOptions";

export default Vue.extend({
    props: {
        msg: String,
        options: Object as () => ToastOptions,
    },

    data: () => ({
        isVisible: false,
        iconName: "",
        backgroundColor: "",
        textColor: "#1a202c",
        duration: 0,
    }),

    computed: {
        theStyle(): { [key: string]: string } {
            return {
                padding: "0.5rem 1rem 0.5rem 1rem",
                backgroundColor: this.backgroundColor,
                color: this.textColor,
                fontWeight: "600",
            };
        }
    },

    mounted() {
        Vue.nextTick().then(() => this.isVisible = true);
        setTimeout(() => {
            this.isVisible = false;
            Vue.nextTick().then(() => this.$emit("close"));
        }, this.duration);
    },

    created() {
        let opts = this.options;

        if (!opts) {
            opts = {
                type: "info",
            };
        }

        this.duration = opts.duration || 2000;

        switch (opts.type) {
            case "success":
                this.iconName = "abc-icon-check";
                this.backgroundColor = "#5ba475";
                this.textColor = "#f7fafc";
                break;
            case "error":
                this.iconName = "abc-icon-exclamation-point-triangle";
                this.backgroundColor = "#e53e3e";
                this.textColor = "#f7fafc";
                break;
            case "info":
                this.iconName = "abc-icon-square-i";
                this.backgroundColor = "#FFD24D";
                break;
            case "warn":
                this.iconName = "abc-icon-exclamation-point";
                this.backgroundColor = "#F6993F";
                break;
            default:
                break;
        }
    },
});
